import React, { useState, useEffect, useRef, useMemo } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableUtils from '../../utilities/DataTableUtils';
import { CompetitionService } from '../../service/CompetitionService';


const CompetitionOtherCompetencyListViewComponent = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [competencyList, setCompetencyList] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getOtherCompetency = async () => {
            await competitionService.getCompetitionOtherCompetencyList(props?.competition?.id)
                .then((_itList) => {
                    // console.log("itList: ", _itList);
                    setCompetencyList(_itList);
                    setIsLoading(false);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };
    
        getOtherCompetency()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, competitionService]);


    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast}></Toast>
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage('competition.requirements.otherCompetency')}</h5>
                    <DataTable
                        ref={dt}
                        value={competencyList}
                        dataKey="id"
                        // paginator
                        rows={DataTableUtils.defalRowsPerPage()}
                        rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                        emptyMessage={translatedMessage("generic.tableEmptyMessage")}
                        responsiveLayout="scroll"
                    >
                        <Column
                            field="name"
                            header={translatedMessage("generic.nameRo")}
                            headerStyle={{ width: '15%', minWidth: '8rem' }}
                        />
                        <Column
                            field="proofingMethod"
                            header={translatedMessage("competition.requirements.otherCompetency.proofing")}
                            headerStyle={{ width: '65%', minWidth: '8rem' }}
                        />
                    </DataTable>
                </div>
            </>
        );
    }
};

export default CompetitionOtherCompetencyListViewComponent;
